export default __webpack_public_path__ + "static/media/IconDesc_PlutoniumWaste.256.3d887210.png";